require('../../../modules/es.array.index-of');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').indexOf;